import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { FONT_FAMILY_SCHEMA, getFontFamily } from '../fonts';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const ButtonPropsSchema = z.object({
    style: z
        .object({
        backgroundColor: COLOR_SCHEMA,
        fontSize: z.number().min(0).optional().nullable(),
        fontFamily: FONT_FAMILY_SCHEMA,
        fontWeight: z.enum(['bold', 'normal']).optional().nullable(),
        textAlign: z.enum(['left', 'center', 'right']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        buttonBackgroundColor: COLOR_SCHEMA,
        buttonStyle: z.enum(['rectangle', 'pill', 'rounded']).optional().nullable(),
        buttonTextColor: COLOR_SCHEMA,
        fullWidth: z.boolean().optional().nullable(),
        size: z.enum(['x-small', 'small', 'large', 'medium']).optional().nullable(),
        text: z.string().optional().nullable(),
        url: z.string().optional().nullable(),
    })
        .optional()
        .nullable(),
});
function getRoundedCorners(props) {
    var _e;
    const buttonStyle = (_e = props === null || props === void 0 ? void 0 : props.buttonStyle) !== null && _e !== void 0 ? _e : 'rounded';
    switch (buttonStyle) {
        case 'rectangle':
            return undefined;
        case 'pill':
            return 64;
        case 'rounded':
        default:
            return 4;
    }
}
function getButtonSizePadding(props) {
    var _e;
    const size = (_e = props === null || props === void 0 ? void 0 : props.size) !== null && _e !== void 0 ? _e : 'medium';
    switch (size) {
        case 'x-small':
            return [4, 8];
        case 'small':
            return [8, 12];
        case 'large':
            return [16, 32];
        case 'medium':
        default:
            return [12, 20];
    }
}
export function Button({ style, props }) {
    var _e, _t, _y, _10;
    const text = props === null || props === void 0 ? void 0 : props.text;
    const url = props === null || props === void 0 ? void 0 : props.url;
    const fullWidth = props === null || props === void 0 ? void 0 : props.fullWidth;
    const buttonTextColor = props === null || props === void 0 ? void 0 : props.buttonTextColor;
    const buttonBackgroundColor = props === null || props === void 0 ? void 0 : props.buttonBackgroundColor;
    const padding = getButtonSizePadding(props);
    const textRaise = (padding[1] * 2 * 3) / 4;
    const wrapperStyle = {
        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _e !== void 0 ? _e : undefined,
        textAlign: (_t = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _t !== void 0 ? _t : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    const linkStyle = {
        color: buttonTextColor,
        fontSize: (_y = style === null || style === void 0 ? void 0 : style.fontSize) !== null && _y !== void 0 ? _y : 16,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_10 = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _10 !== void 0 ? _10 : 'bold',
        backgroundColor: buttonBackgroundColor,
        borderRadius: getRoundedCorners(props),
        display: fullWidth ? 'block' : 'inline-block',
        padding: `${padding[0]}px ${padding[1]}px`,
        textDecoration: 'none',
    };
    return (React.createElement("div", { style: wrapperStyle },
        React.createElement("a", { href: url, style: linkStyle, target: "_blank" },
            React.createElement("span", { dangerouslySetInnerHTML: {
                    __html: `<!--[if mso]><i style="letter-spacing: ${padding[1]}px;mso-font-width:-100%;mso-text-raise:${textRaise}" hidden>&nbsp;</i><![endif]-->`,
                } }),
            React.createElement("span", null, text),
            React.createElement("span", { dangerouslySetInnerHTML: {
                    __html: `<!--[if mso]><i style="letter-spacing: ${padding[1]}px;mso-font-width:-100%" hidden>&nbsp;</i><![endif]-->`,
                } }))));
}
//# sourceMappingURL=Button.js.map